import { EyePlusOutlineIcon } from './EyePlusOutlineIcon';

/**
 * author: GreenTurtwig
 * id C82BEE88-7AAC-4F8D-9A8A-4B0C7CCDF216
 * name eye-plus-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-plus-outline.svg
 * tags
 */
export const EyeAddOutlineIcon = EyePlusOutlineIcon;
export default EyeAddOutlineIcon